export default "__VITE_ASSET__D6i_Fqp3__"